import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useUserContext from 'Context/UserContext';
import PreviousButton from './PreviousButton';

const PreviousButtonPicker = (props) => {
  const { agentResource } = useUserContext();


  return pickFunction(agentResource, {
    [fr.relationships.generatedView.name]: () => {
      return (
        <PreviousButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default PreviousButtonPicker;
